import { CalculatorV2StepModel } from "../models/calculator-configuration";
import { CalculatorQuestion } from "../models/CalculatorStep";

export function mapQuestionsConfig(
  questions: CalculatorQuestion[],
  config: CalculatorV2StepModel
): CalculatorQuestion[] {
  return questions.map((question) => {
    if (!config.Questions[question.field]) {
      console.debug("No question available for", question.field);
      return question;
    }

    const mappedQuestion = {
      ...question,
      title: config.Questions[question.field].Title,
      description: config.Questions[question.field].Description,
      explanation: config.Questions[question.field].Explanation,
    };

    if (mappedQuestion.input === "option") {
      mappedQuestion.options = mappedQuestion.options.filter(o => config.Questions[question.field].Options.some(co => co.Value === o.value)).map((option) => ({
        ...option,
        text: config.Questions[question.field].Options.find((o) => o.Value === option.value)?.Text || option.text,
        message: config.Questions[question.field].Options.find((o) => o.Value === option.value)?.Message,
      }));
    }

    // date use options to limit the min/max age and display messages based on it
    if (mappedQuestion.input === "date") {
      mappedQuestion.options = config.Questions[question.field].Options?.map(option => ({
        value: option.Value,
        message: option.Message,
      }));
    }

    return mappedQuestion;
  });
}
